import styled from 'styled-components'
// icons
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'

export const FieldSettingsWrapper = styled.div`
  cursor: default;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 16px;

  > :last-child {
    align-self: center;
  }
`

export const IconWrapper = styled.div`
  margin-left: -4px;
  height: 24px;

  svg {
    cursor: pointer;
  }
`

export const ArrowIcon = styled(ArrowRightAltIcon)`
  transform: rotate(180deg);
`

export const FieldLabel = styled.div`
  font-weight: bold;
`
